module.exports = __webpack_public_path__ + "img/harmony.4b29889f.png";